import {Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {BannersHttpService} from '../../../../../services/http-services/banners/banners-http.service';
import {GrBanner} from '../../../../../interfaces/banners-interfaces';
import {ToastrService} from 'ngx-toastr';
import {UrlRegex} from '../../../../../constants/general-variables';
import {debounceTime, distinctUntilChanged} from 'rxjs/operators';
import {InputDebounceTime} from '../../../../../enums/general-enums';
import {Subject} from 'rxjs';
import {BannerLinkTypeEnums, BannerTypeEnum} from '../../../../../enums/banner-enums';

export const DurationOfBanner = [
  {name: '7 dana', value: '7_days'},
  {name: '14 dana', value: '14_days'},
  {name: '21 dana', value: '21_days'},
  {name: '1 mesec', value: '1_month'},
  {name: '3 meseca', value: '3_months'},
  {name: '6 meseci', value: '6_months'},
  {name: '1 godina', value: '1_year'},
];

@Component({
  selector: 'gr-create-or-edit-banner-modal',
  templateUrl: './create-or-edit-banner-modal.component.html',
})
export class CreateOrEditBannerModalComponent implements OnInit, OnChanges {
  @Input() activeTab = BannerTypeEnum.application;
  createOrEditBannerForm!: FormGroup;
  formTriedToSubmit = false;
  imageUrl = '';
  searchTerm = '';
  autocompleteSubject = new Subject<string>();
  autocompleteLinkSuggestions: any[] = [];
  isStopAutosuggestionActive = false;
  bannerPositionArray: any = [
    {name: 'A', value: 1},
    {name: 'B', value: 2},
    {name: 'C', value: 3},
    {name: 'D', value: 4},
    {name: 'E', value: 5},
    {name: 'F', value: 6},
    {name: 'G', value: 7}
  ];
  landingBannerPositionArray: any = [{name: 1, value: 1}, {name: 2, value: 2}, {name: 3, value: 3}, {name: 4, value: 4}, {name: 5, value: 5}, {name: 6, value: 6}, {name: 7, value: 7}];
  protected readonly BannerTypeEnum = BannerTypeEnum;
  protected readonly DurationOfBanner = DurationOfBanner;
  @Input() bannerForEdit: GrBanner | null = null;
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();
  @Output() confirmModal: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  constructor(private formBuilder: FormBuilder,
              private toastrService: ToastrService,
              private bannersHttpService: BannersHttpService) {
  }

  ngOnInit(): void {
    this.buildForm();
    this.createOrEditBannerForm.controls.link_type.valueChanges.subscribe(value => {
      this.createOrEditBannerForm.controls.link.patchValue('');
      this.searchTerm = '';
      this.autocompleteLinkSuggestions = [];
      if (this.createOrEditBannerForm.controls.link_type.value === BannerLinkTypeEnums.company || this.createOrEditBannerForm.controls.link_type.value === BannerLinkTypeEnums.category) {
        this.getBannerLinks();
        this.createOrEditBannerForm.controls.link.setValidators([Validators.required]);
      } else {
        this.createOrEditBannerForm.controls.link.setValidators([Validators.required, Validators.pattern(UrlRegex)]);
      }
      this.createOrEditBannerForm.controls.link.updateValueAndValidity();
    });
    this.debounceLinkInput();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.activeTab && changes.activeTab.currentValue) {
      this.bannerPositionArray = (changes.activeTab.currentValue === BannerTypeEnum.application)
        ? [
            {name: 'A', value: 1},
            {name: 'B', value: 2},
            {name: 'C', value: 3},
            {name: 'D', value: 4},
            {name: 'E', value: 5},
            {name: 'F', value: 6},
            {name: 'G', value: 7}
          ]
        : [
            {name: 'A', value: 'A', positions: [{name: 1, value: 1}, {name: 2, value: 2}, {name: 3, value: 3}, {name: 4, value: 4}, {name: 5, value: 5}, {name: 6, value: 6}, {name: 7, value: 7}]},
            {name: 'B', value: 'B', positions: [{name: 1, value: 1}, {name: 2, value: 2}, {name: 3, value: 3}]},
            {name: 'C', value: 'C'},
            {name: 'D', value: 'D'},
            {name: 'E', value: 'E'},
            {name: 'F', value: 'F', positions: [{name: 1, value: 1}, {name: 2, value: 2}, {name: 3, value: 3}]}
          ];
    }
  }

  buildForm(): void {
    this.createOrEditBannerForm = this.formBuilder.group({
      active: [true],
      image: [null, Validators.required],
      link_type: ['company'],
      link: ['', Validators.required],
      type: ['A', Validators.required],
      position: [1, Validators.required],
      name: [''],
      description: [''],
      time: ['']
    });
    if (this.bannerForEdit) {
      this.createOrEditBannerForm.patchValue(this.bannerForEdit);
      this.createOrEditBannerForm.controls.active.patchValue(!!this.bannerForEdit.active);
      this.createOrEditBannerForm.controls.image.patchValue('not changed');
      this.searchTerm = this.bannerForEdit.link;
      this.imageUrl = this.bannerForEdit?.image.full_path;
    }

    if (this.activeTab === BannerTypeEnum.landing) {
      this.createOrEditBannerForm.controls.type.setValidators([Validators.required]);
      this.createOrEditBannerForm.controls.name.setValidators([Validators.required]);
      this.createOrEditBannerForm.controls.description.setValidators([Validators.required]);
      if (!this.bannerForEdit) {
        this.createOrEditBannerForm.controls.time.setValidators([Validators.required]);
        this.createOrEditBannerForm.controls.active.valueChanges.subscribe(value => {
          value
            ? this.createOrEditBannerForm.controls.time.setValidators([Validators.required])
            : this.createOrEditBannerForm.controls.time.clearValidators();
          this.createOrEditBannerForm.controls.time.updateValueAndValidity();

        });
      }
      this.createOrEditBannerForm.controls.type.valueChanges.subscribe(value => {
        if (value === 'A') {
          this.createOrEditBannerForm.controls.name.setValidators([Validators.required]);
          this.createOrEditBannerForm.controls.description.setValidators([Validators.required]);
        } else {
          this.createOrEditBannerForm.controls.name.clearValidators();
          this.createOrEditBannerForm.controls.description.clearValidators();
        }
        this.createOrEditBannerForm.controls.name.updateValueAndValidity();
        this.createOrEditBannerForm.controls.description.updateValueAndValidity();
      });
    } else {
      this.createOrEditBannerForm.controls.type.clearValidators();
      this.createOrEditBannerForm.controls.name.clearValidators();
      this.createOrEditBannerForm.controls.description.clearValidators();
      this.createOrEditBannerForm.controls.time.clearValidators();
    }
    this.createOrEditBannerForm.updateValueAndValidity();
  }

  getBannerLinks(): void {
    this.bannersHttpService.getAutocompleteLink({linkType: this.createOrEditBannerForm.controls.link_type.value, searchTerm: this.searchTerm}).then(res => {
      this.autocompleteLinkSuggestions = res.data;
    });
  }

  debounceLinkInput(): void {
    this.autocompleteSubject.pipe(
      debounceTime(InputDebounceTime.time),
      distinctUntilChanged())
      .subscribe(value => {
        this.searchTerm = value;
        (!this.isStopAutosuggestionActive && (this.createOrEditBannerForm.controls.link_type.value === BannerLinkTypeEnums.company || this.createOrEditBannerForm.controls.link_type.value === BannerLinkTypeEnums.category))
          ? this.getBannerLinks()
          : this.createOrEditBannerForm.controls.link.patchValue(this.searchTerm);
      });
  }

  changeBannerType(groupIndex: number): void {
    this.landingBannerPositionArray = this.bannerPositionArray[groupIndex].positions;
    this.createOrEditBannerForm.controls.position.patchValue(1);
  }

  onSelectSuggestionLink(suggestion: any): void {
    (this.createOrEditBannerForm.controls.link_type.value === BannerLinkTypeEnums.company)
      ? this.createOrEditBannerForm.controls.link.patchValue(`category/${suggestion.business_category_id}/item/${suggestion.id}`)
      : suggestion.id === 7
        ? this.createOrEditBannerForm.controls.link.patchValue('presents-profile')
        : this.createOrEditBannerForm.controls.link.patchValue(`category/${suggestion.id}`);
    this.isStopAutosuggestionActive = true;
    setTimeout(() => {
      this.isStopAutosuggestionActive = false;
    }, 1000);
    this.searchTerm = this.createOrEditBannerForm.controls.link.value;
    this.autocompleteLinkSuggestions = [];
  }

  onFileChange(event: any): void {
    const file = event.target.files[0];
    if (file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/jpg' && file.type !== 'image/svg') {
      this.toastrService.warning('Pogrešan tip dokumenta. Samo JPG, JPEG, SVG i PNG formati su dozvoljeni.');
      return;
    } else if (file?.size > 10485760) {
      this.toastrService.warning(`Slika ${file.name} je veća od 10MB.`);
      return;
    } else {
      this.createOrEditBannerForm.controls.image.patchValue(event.target.files[0]);
      this.imageUrl = URL.createObjectURL(file);
      this.fileInput.nativeElement.value = '';
    }
  }

  removeFile(): void {
    this.createOrEditBannerForm.controls.image.patchValue(null);
    this.imageUrl = '';
  }


  submitCreateOrEditBannerForm(): void {
    this.formTriedToSubmit = true;
    if (this.createOrEditBannerForm.valid) {
      const formData = new FormData();
      for (const key in this.createOrEditBannerForm.value) {
        if (this.createOrEditBannerForm.value[key] && this.createOrEditBannerForm.value[key] !== 'not changed') {
          formData.append(key, this.createOrEditBannerForm.value[key]);
        }
      }
      this.bannerForEdit
        ? this.bannersHttpService.putBanner({bannerId: this.bannerForEdit?.id}, formData, this.activeTab === BannerTypeEnum.landing).then(res => {
            this.toastrService.success('Uspešno ste izmenili baner.');
            this.confirmModal.emit();
          }).catch(({error}: {error: { errors: { [key: string]: string } }}) => {
            Object.values(error.errors).forEach(error => this.toastrService.error(error));
          })
        : this.bannersHttpService.postBanner(formData, this.activeTab === BannerTypeEnum.landing).then(res => {
            this.toastrService.success('Uspešno ste kreirali baner.');
            this.confirmModal.emit();
          }).catch(({error}: {error: { errors: { [key: string]: string } }}) => {
            Object.values(error.errors).forEach(error => this.toastrService.error(error));
          });
    }
  }
}
